import React from "react";
import { useApp } from "../context/AppContext";
import { ITE_EVENTS } from "../data/mockData";
import { Tag, Btn } from "./atoms";
import { X, Check, Mail } from "lucide-react";

const F = "'Montserrat',sans-serif";

const CAMPAIGNS = [
  {id:1,name:"WorldFood 2026 — Exhibitor Acquisition",type:"Email Sequence",platform:"Active Campaign",status:"Active",contacts:342,lastSent:"28 May 2026"},
  {id:2,name:"New Exhibitor Welcome Series",type:"Nurture",platform:"Active Campaign",status:"Active",contacts:128,lastSent:"25 May 2026"},
  {id:3,name:"MosBuild — Past Exhibitor Re-engagement",type:"Re-engagement",platform:"Mindbox",status:"Active",contacts:86,lastSent:"20 May 2026"},
  {id:4,name:"WorldFood 2026 — Event Invitation",type:"Event Invitation",platform:"Active Campaign",status:"Draft",contacts:0,lastSent:"—"},
  {id:5,name:"Competitor Show Exhibitors — Cold Outreach",type:"Cold Outreach",platform:"Mindbox",status:"Active",contacts:215,lastSent:"22 May 2026"},
  {id:6,name:"High Priority Leads — Fast Track",type:"Email Sequence",platform:"Active Campaign",status:"Active",contacts:94,lastSent:"27 May 2026"},
];

const typeColor = (t) =>
  t==="Email Sequence" ? ["#E8431A","#FCEBE5"] :
  t==="Nurture"        ? ["#16a34a","#dcfce7"] :
  t==="Re-engagement"  ? ["#9a5b00","#fef4e6"] :
  t==="Event Invitation"? ["#5F1156","#EFDDE8"] :
                          ["#3F3F46","#F4F4F5"];

export default function CampaignModal() {
  const { campaignModal, setCampaignModal, selectedEvent } = useApp();
  if (!campaignModal) return null;

  const cos = campaignModal.companies || [];
  const currentEvent = ITE_EVENTS.find(e => e.id === selectedEvent);

  return (
    <div
      style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:999 }}
      onClick={() => setCampaignModal(null)}
    >
      <div onClick={e => e.stopPropagation()} style={{
        background:"#fff", borderRadius:14, width:680, maxHeight:"85vh",
        overflow:"auto", padding:"28px", boxShadow:"0 20px 60px rgba(0,0,0,0.3)",
      }}>
        {/* Header */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div>
            <div style={{ fontSize:18, fontWeight:800 }}>Add to Campaign</div>
            <div style={{ fontSize:11, color:"#818084", marginTop:2 }}>
              {cos.length === 1 ? `Add ${cos[0].name} to a marketing campaign` : `Add ${cos.length} companies to a marketing campaign`}
            </div>
          </div>
          <span onClick={() => setCampaignModal(null)} style={{ cursor:"pointer", color:"#818084" }}><X size={18} /></span>
        </div>

        {/* Selected companies */}
        <div style={{ background:"#FAFAFA", borderRadius:8, padding:"12px 14px", marginBottom:16, border:"1px solid #D8DADC" }}>
          <div style={{ fontSize:10, fontWeight:600, color:"#818084", textTransform:"uppercase", letterSpacing:0.4, marginBottom:6 }}>Selected Companies ({cos.length})</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:4 }}>
            {cos.slice(0, 8).map((c, i) => <Tag key={i} label={`${c.flag || ""} ${c.name}`} c="#3F3F46" bg="#D8DADC" />)}
            {cos.length > 8 && <Tag label={`+${cos.length - 8} more`} c="#818084" bg="#F4F4F5" />}
          </div>
        </div>

        {/* Platform selector */}
        <div style={{ display:"flex", gap:8, marginBottom:16 }}>
          <div style={{ flex:1, padding:"12px 14px", borderRadius:8, border:"2px solid #E8431A", background:"#FCEBE5", cursor:"pointer", textAlign:"center" }}>
            <div style={{ fontSize:13, fontWeight:700, color:"#E8431A" }}>Active Campaign</div>
            <div style={{ fontSize:9, color:"#818084", marginTop:2 }}>Email sequences & automation</div>
          </div>
          <div style={{ flex:1, padding:"12px 14px", borderRadius:8, border:"2px solid #D8DADC", background:"#fff", cursor:"pointer", textAlign:"center" }}>
            <div style={{ fontSize:13, fontWeight:700, color:"#3F3F46" }}>Mindbox</div>
            <div style={{ fontSize:9, color:"#818084", marginTop:2 }}>CDP & omnichannel campaigns</div>
          </div>
        </div>

        {/* Campaign list */}
        <div style={{ fontSize:12, fontWeight:700, marginBottom:8 }}>Select Campaign</div>
        <div style={{ maxHeight:220, overflow:"auto", border:"1px solid #D8DADC", borderRadius:8, marginBottom:16 }}>
          {CAMPAIGNS.map((camp, i) => {
            const [tC, tBg] = typeColor(camp.type);
            return (
              <div key={camp.id} style={{
                display:"flex", alignItems:"center", gap:12, padding:"10px 14px",
                borderBottom: i < CAMPAIGNS.length - 1 ? "1px solid #F4F4F5" : "none",
                cursor:"pointer", transition:"background 0.1s",
              }}
                onMouseEnter={e => e.currentTarget.style.background = "#FAFAFA"}
                onMouseLeave={e => e.currentTarget.style.background = "#fff"}
              >
                <input type="radio" name="campaign" style={{ accentColor:"#E8431A" }} defaultChecked={i === 0} />
                <div style={{ flex:1 }}>
                  <div style={{ fontSize:12, fontWeight:600 }}>{camp.name}</div>
                  <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:3 }}>
                    <Tag label={camp.type} c={tC} bg={tBg} />
                    <Tag label={camp.platform} c="#818084" bg="#F4F4F5" />
                    <Tag label={camp.status} c={camp.status === "Active" ? "#16a34a" : "#818084"} bg={camp.status === "Active" ? "#dcfce7" : "#F4F4F5"} />
                  </div>
                </div>
                <div style={{ textAlign:"right" }}>
                  <div style={{ fontSize:12, fontWeight:600 }}>{camp.contacts}</div>
                  <div style={{ fontSize:8, color:"#818084" }}>contacts</div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Options */}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"#3F3F46", display:"block", marginBottom:4 }}>Tags to Apply</label>
            <input placeholder="e.g. high-priority, worldfood-2026..." style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1px solid #D8DADC", fontSize:11, fontFamily:F, outline:"none", boxSizing:"border-box" }} />
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"#3F3F46", display:"block", marginBottom:4 }}>Custom Field: Source</label>
            <select style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1px solid #D8DADC", fontSize:11, fontFamily:F, color:"#818084", boxSizing:"border-box" }}>
              <option>Competitor Exhibitor Intelligence</option><option>Lead Review</option><option>Manual Entry</option>
            </select>
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"#3F3F46", display:"block", marginBottom:4 }}>ITE Event Context</label>
            <div style={{ padding:"8px 12px", borderRadius:8, background:"#f0fdf4", border:"1px solid #dcfce7", fontSize:11, color:"#16a34a", fontWeight:600 }}>
              {currentEvent ? currentEvent.name : "No event selected"}
            </div>
          </div>
          <div>
            <label style={{ fontSize:11, fontWeight:600, color:"#3F3F46", display:"block", marginBottom:4 }}>Priority</label>
            <select style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1px solid #D8DADC", fontSize:11, fontFamily:F, color:"#818084", boxSizing:"border-box" }}>
              <option>Normal</option><option>High — send immediately</option><option>Low — queue for next batch</option>
            </select>
          </div>
          <div style={{ gridColumn:"1 / -1" }}>
            <label style={{ fontSize:11, fontWeight:600, color:"#3F3F46", display:"block", marginBottom:4 }}>Notes (optional)</label>
            <textarea placeholder="Add context for the campaign..." rows={2} style={{ width:"100%", padding:"8px 12px", borderRadius:8, border:"1px solid #D8DADC", fontSize:11, fontFamily:F, outline:"none", resize:"vertical", boxSizing:"border-box" }} />
          </div>
        </div>

        {/* Data preview */}
        <div style={{ background:"#FAFAFA", borderRadius:8, padding:"12px 14px", marginBottom:16, border:"1px solid #D8DADC" }}>
          <div style={{ fontSize:10, fontWeight:600, color:"#818084", textTransform:"uppercase", letterSpacing:0.4, marginBottom:8 }}>Data that will be synced to campaign</div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:6, fontSize:10 }}>
            {["Company Name","Country","Product Categories","Competitor Shows","Event Fit Score","Export Readiness","Priority Score","ITE Status","Recommended Action","Website","Sales Owner","Region"].map(f => (
              <div key={f} style={{ display:"flex", alignItems:"center", gap:4 }}><Check size={12} color="#16a34a" />{f}</div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", paddingTop:16, borderTop:"1px solid #D8DADC" }}>
          <div style={{ fontSize:9, color:"#818084" }}>Connected to Active Campaign & Mindbox via API. Data synced in real-time.</div>
          <div style={{ display:"flex", gap:8 }}>
            <Btn label="Cancel" onClick={() => setCampaignModal(null)} />
            <button onClick={() => setCampaignModal(null)} style={{
              padding:"8px 24px", borderRadius:8, border:"none", background:"#E8431A",
              color:"#fff", fontSize:12, fontWeight:700, cursor:"pointer", fontFamily:F,
              display:"flex", alignItems:"center", gap:5,
            }}><Mail size={16} /> Add {cos.length} {cos.length === 1 ? "Company" : "Companies"} to Campaign</button>
          </div>
        </div>
      </div>
    </div>
  );
}
